<template>
  <b-card>
    <div>
      <Strong>Super-Wise Performance Report</Strong>
      <b-row>
        <b-col>
          <b-table 
            show-empty 
            stacked="md"
            :items="items"
            :fields="fields"
          >

          </b-table>
        </b-col>
      </b-row>
    </div>
  </b-card>
</template>
  
<script>
import CONSTANTS from '@/utils/constants'
  export default {
    data: function(){
      return{
        name: 'superWisePerformanceReport',
        isBusy: false,
        items: [],
        fields: [
          {key:'driverName',label:'Driver Name'},
          {key:'ofdFreshShipments',label:'OFD Fresh Shipments'},
          {key:'3',label:'OFD Reattempt'},
          {key:'4',label:'Total OFD'},
          {key:'5',label:'OFD Customer Count'},
          {key:'6',label:'Delivery Percentage'},
          {key:'7',label:'Undelivery Percentage'},
          {key:'8',label:'First Attempt Delivery'},

        ]
      }
    },
    created: function(){
      this.getSuperWiseListing();
    },
    methods:{
      getSuperWiseListing: function(){

      },
    }
  };
</script>

<style>

</style>